import { createUseStyles } from 'react-jss'

const useAudioPreviewStyles = createUseStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    margin: '1rem 0'
  },
  audio: {
    flex: '50%',
    display: 'flex',
    '& > audio': {
      marginBottom: '0',
      width: '100%'
    }
  },
  inputContainer: {
    flex: '50%',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '1.5rem'
  },
  propertiesContainer: {
    paddingLeft: '0.5rem',
    minWidth: '30%'
  }
})

export { useAudioPreviewStyles }
